import React from 'react';

import { AnalogDataLoan } from 'types';
import { PageKey, SortOrder } from 'enums';

import { LentTable } from '../lent-table';
import { fetchTableItems } from '../lent-api';
import { lentHistoryPhysicalColumns } from '../lent-columns';

const fetchFunction = fetchTableItems<AnalogDataLoan>(
  '/api/analog-data-loan/my-loans'
);

export function LentHistoryTablePhysical() {
  return (
    <LentTable<AnalogDataLoan>
      title="Vrácené papírové archiválie"
      pageKey={PageKey.PORTFOLIO_LENT_HISTORY_PHYSICAL}
      columns={lentHistoryPhysicalColumns}
      fetchFunction={fetchFunction}
      params={{
        filters: [
          {
            filters: [
              {
                field: 'latestReservationExpiration',
                value: new Date().toISOString(),
                operation: 'LTE',
              },
              {
                field: 'pendingReservation',
                value: 'true',
                operation: 'EQ',
              },
            ],
            operation: 'OR',
          },
        ],
        sort: [
          { field: 'archivalUnitReference.numericId', order: SortOrder.ASC },
        ],
      }}
    />
  );
}
